module.exports = __webpack_public_path__ + "img/SelectedFeedbackPoor.36e35e7d.png";